export enum CompanyMode {
    CUSTOMER = 'CUSTOMER',
    PARTNER = 'PARTNER',
    REGULATOR = 'REGULATOR'
}
